import { Submission } from '@interhyp/module-credit';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { COMMUNICATION_PLUGIN_ENABLED } from '../../../constants/env';
import { Navigation, NavItems } from '../../navigation/Navigation';

import '@interhyp/shared-credit/esm/index.css';
import '@interhyp/module-credit/esm/index.css';

export interface SubmissionOverviewWrapperProps {
  currentUserId: string;
  providerId: string;
}

export function SubmissionOverviewWrapper({
  currentUserId,
  providerId,
}: SubmissionOverviewWrapperProps): JSX.Element {
  const { submissionId } = useParams<{ submissionId: string }>();
  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/credit/submissions/${submissionId}`, translation: 'navigation.summary' },
      { to: `/credit/submissions/${submissionId}/documents`, translation: 'navigation.documents' },
      ...(COMMUNICATION_PLUGIN_ENABLED
        ? [
            {
              to: `/credit/submissions/${submissionId}/communication`,
              translation: 'navigation.communication',
            },
          ]
        : []),
    ];
  }, [submissionId]);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <Submission
        submissionId={submissionId}
        providerId={providerId}
        currentUserId={currentUserId}
      />
    </>
  );
}
